module.exports = __webpack_public_path__ + "img/preview-bg.1759d62c.png";